import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Gift } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export function RedeemCodeInline({ onDone }) {
  const { reload } = useAuth();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!code.trim()) { toast.error("Enter an access code"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/access-codes/redeem", { code: code.trim() });
      toast.success(`You're on ${data.plan_name} - free, forever`);
      await reload();
      onDone?.(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not redeem that code");
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="flex flex-wrap items-center gap-2" data-testid="redeem-inline-form">
      <Input
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        placeholder="TENX-XXXX-XXXX"
        className="h-10 w-52 font-mono uppercase"
        data-testid="redeem-code-input"
      />
      <Button type="submit" disabled={busy} className="h-10 gap-1.5" data-testid="redeem-code-submit">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Gift className="h-4 w-4" />} Redeem
      </Button>
    </form>
  );
}
